var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evaluationreport",attrs:{"id":"evaluationreport"}},[(_vm.selectedEvaluation)?_c('b-modal',{ref:"reportModalRef",attrs:{"id":"modalReport","title":"Report"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f59e7a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EvaluationReport.vue
// module id = null
// module chunks = 